export default {
  state: {
    jumpData: {}
  },
  mutations: {
    setJumpData(state, val) {
      state.jumpData = val
    }
  }
}